module.exports = __webpack_public_path__ + "static/media/chrome-brands-purple.8cac9dd6.svg";